import store from "../store";
import {
  SET_CLASSIFICATION,
  SET_CLINVAR_SUBMISSIONS,
  SET_CLINVAR_TOKEN,
  SET_SUBMISSION_REFRESH,
} from "./actionTypes";

export function setClinvarToken(token) {
  store.dispatch({
    type: SET_CLINVAR_TOKEN,
    clinvarToken: token,
  });
}

export function setClinvarSubmissions(submissions) {
  store.dispatch({
    type: SET_CLINVAR_SUBMISSIONS,
    clinvarSubmissions: submissions,
  });
}

export function setClassification(classification) {
  store.dispatch({
    type: SET_CLASSIFICATION,
    classification,
  });
}

export function setSubmissionRefresh(number) {
  store.dispatch({
    type: SET_SUBMISSION_REFRESH,
    clinvarSubmissionListRefresh: number,
  });
}
